var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SingleMailComposer',{attrs:{"card-title":_vm.$t('sendWelcomeMail'),"card-text":_vm.$t('sendWelcomeMailInfo'),"cancel-btn-txt":_vm.$t('dontSend'),"init-mail-subject":_vm.$t('welcomeToGA'),"to-email":_vm.toEmail,"to-name":_vm.toName,"sender-name":_vm.senderName,"init-email-text":_vm.mailBody},on:{"done":_vm.emitDone}})
}
var staticRenderFns = []

export { render, staticRenderFns }